export const quickTakeData = {
  distance: "90 miles (145 km)",
  travelTime: "2.5–3.5 hours each way",
  marketDays: "Thursday & Sunday only",
  idealFor: "Culture enthusiasts, photographers, shoppers, 2-week itinerary travelers",
  skipIf: "You only have 3 days in Antigua, prefer nature over markets, or dislike long drives"
};

export const travelOptionsData = [
  {
    option: "Organized Tour",
    cost: "$35–$50",
    comfort: "High",
    travelTime: "3–3.5 hours",
    pros: "Guide included, no planning needed, cultural context provided",
    cons: "Fixed schedule, less flexibility, group pace"
  },
  {
    option: "Shuttle Service",
    cost: "$25–$35",
    comfort: "Medium",
    travelTime: "2.5–3 hours",
    pros: "Affordable, direct route, comfortable",
    cons: "No guide, limited time at market, fixed departure"
  },
  {
    option: "Private Driver",
    cost: "$80–$120",
    comfort: "Very High",
    travelTime: "2.5 hours",
    pros: "Flexible schedule, door-to-door, can combine with Lake Atitlán",
    cons: "Most expensive, need to negotiate"
  },
  {
    option: "Chicken Bus",
    cost: "$3–$5",
    comfort: "Low",
    travelTime: "4+ hours",
    pros: "Authentic experience, very cheap",
    cons: "Multiple transfers, crowded, no AC, pickpocket risk"
  }
];

export const costBreakdownData = [
  { item: "Organized Tour", cost: "$35–$50" },
  { item: "Shuttle (round-trip)", cost: "$25–$35" },
  { item: "Private Driver", cost: "$80–$120" },
  { item: "Market Entrance", cost: "Free" },
  { item: "Lunch", cost: "$5–$10" },
  { item: "Shopping Budget", cost: "$20–$100+" },
  { item: "Typical Total (Tour)", cost: "$60–$110" }
];

export const whatToBuyData = [
  {
    category: "Textiles",
    items: "Huipiles (traditional blouses), table runners, blankets, scarves",
    priceRange: "$15–$150",
    tip: "Quality varies widely—check stitching and fabric weight"
  },
  {
    category: "Masks",
    items: "Wooden ceremonial masks, decorative wall pieces",
    priceRange: "$10–$80",
    tip: "Antique-looking masks are usually new—real antiques are rare"
  },
  {
    category: "Ceramics",
    items: "Hand-painted pottery, incense burners, decorative plates",
    priceRange: "$5–$40",
    tip: "Fragile—bring bubble wrap or buy at end of trip"
  },
  {
    category: "Jade & Silver",
    items: "Jewelry, small carvings",
    priceRange: "$10–$200+",
    tip: "Authenticity varies—buy from established vendors"
  }
];

export const timelineData = [
  { time: "6:00–7:00 AM", activity: "Pickup from Antigua hotel", duration: "—" },
  { time: "7:00–9:30 AM", activity: "Drive to Chichicastenango", duration: "2.5–3 hours" },
  { time: "9:30 AM–12:30 PM", activity: "Explore market & Santo Tomás Church", duration: "3 hours" },
  { time: "12:30–1:30 PM", activity: "Lunch break", duration: "1 hour" },
  { time: "1:30–2:30 PM", activity: "Final shopping & photos", duration: "1 hour" },
  { time: "2:30–5:00 PM", activity: "Return drive to Antigua", duration: "2.5–3 hours" },
  { time: "5:00–6:00 PM", activity: "Arrive back in Antigua", duration: "—" }
];

export const proTips = [
  {
    title: "Go on Thursday if possible",
    description: "Sunday is more crowded with tourists. Thursday has a more local feel and better prices."
  },
  {
    title: "Arrive early",
    description: "The market is most vibrant 9 AM–1 PM. After 2 PM, vendors start packing up."
  },
  {
    title: "Bring small bills",
    description: "Vendors rarely have change for Q100 or Q200 notes. Bring Q20, Q50, and coins."
  },
  {
    title: "Negotiate respectfully",
    description: "Bargaining is expected, but don't lowball. Aim for 20–30% off the first price."
  },
  {
    title: "Ask before photographing people",
    description: "Many Indigenous vendors prefer not to be photographed. Always ask permission first."
  },
  {
    title: "Wear comfortable shoes",
    description: "The market covers steep cobblestone streets. Wear closed-toe shoes with good grip."
  }
];

export const commonMistakes = [
  "Visiting on a non-market day (Monday–Wednesday, Friday–Saturday)",
  "Expecting a 'hidden gem'—it's very touristy",
  "Not bringing cash (few vendors accept cards)",
  "Buying everything at the first stall (prices vary significantly)",
  "Skipping Santo Tomás Church (one of the most important sites)",
  "Wearing expensive jewelry or carrying large camera bags",
  "Leaving too late and hitting return traffic"
];

export const faqData = [
  {
    question: "Is Chichicastenango worth visiting from Antigua?",
    answer: "Yes, if you have 5+ days in Guatemala and are interested in Indigenous culture, textiles, or photography. It's one of Central America's largest traditional markets. However, if you only have 3 days in Antigua, prioritize Acatenango or Pacaya volcano instead—the 6-hour round-trip drive is a significant time investment."
  },
  {
    question: "How do I get from Antigua to Chichicastenango?",
    answer: "The most common options are organized tours ($35–$50), shuttle services ($25–$35), or private drivers ($80–$120). Tours include a guide and cultural context. Shuttles are cheaper but offer no commentary. Private drivers give you the most flexibility. Chicken buses are possible but require multiple transfers and take 4+ hours each way."
  },
  {
    question: "What days is Chichicastenango market open?",
    answer: "The main market operates only on Thursday and Sunday. These are the only days worth visiting—the town is quiet on other days. Thursday tends to be less crowded with tourists than Sunday."
  },
  {
    question: "How long does it take to get from Antigua to Chichicastenango?",
    answer: "The drive takes 2.5–3.5 hours each way depending on traffic and your mode of transport. Tours and shuttles typically take 3–3.5 hours due to pickups. Private drivers can make it in 2.5 hours. Plan for a full-day trip (10–12 hours total including market time)."
  },
  {
    question: "Is Chichicastenango safe for tourists?",
    answer: "Yes, Chichicastenango is generally safe during market days when there's a strong tourist and police presence. Petty theft (pickpocketing) is the main concern in crowded areas. Keep valuables secure, don't flash cash, and stay aware of your surroundings. Avoid walking alone in empty side streets."
  },
  {
    question: "What should I buy at Chichicastenango market?",
    answer: "Popular items include handwoven textiles (huipiles, table runners, blankets), wooden masks, ceramics, jade jewelry, and leather goods. Textiles offer the best quality-to-price ratio. Expect to pay $15–$150 for quality textiles, $10–$80 for masks, and $5–$40 for ceramics. Always negotiate—vendors expect it."
  },
  {
    question: "Can I combine Chichicastenango with Lake Atitlán?",
    answer: "Yes, this is a popular combination if you hire a private driver. Chichicastenango is roughly halfway between Antigua and Lake Atitlán. You can visit the market in the morning, then continue to Panajachel or another lakeside town (adds 1.5–2 hours). This works best as an overnight trip rather than a day trip."
  },
  {
    question: "Do I need a guide for Chichicastenango?",
    answer: "Not required, but recommended for first-time visitors. A guide provides cultural context about the K'iche' Maya traditions, explains the significance of Santo Tomás Church, and helps you navigate the market efficiently. Tours include guides; shuttles don't. You can also hire a local guide at the market for $20–$30."
  },
  {
    question: "What time should I leave Antigua for Chichicastenango?",
    answer: "Leave Antigua by 6:30–7:00 AM to arrive at the market by 9:30–10:00 AM when it's most active. The market peaks between 9 AM and 1 PM. Vendors start packing up after 2 PM. Plan to leave Chichicastenango by 2:30–3:00 PM to avoid evening traffic back to Antigua."
  },
  {
    question: "Is Chichicastenango market touristy?",
    answer: "Yes, very. It's been on the tourist circuit for decades. However, it remains an important market for local K'iche' Maya communities who come to buy and sell goods. The scale and cultural significance are authentic, even if many vendors now cater to tourists. Thursday is less touristy than Sunday."
  },
  {
    question: "What's the difference between Chichicastenango and Antigua's markets?",
    answer: "Chichicastenango is 10x larger, focuses heavily on textiles and handicrafts, and serves as a regional hub for Indigenous communities. Antigua's markets (like the daily artisan market) are smaller, more convenient, but offer less variety and higher prices. If you're serious about buying textiles, Chichicastenango is worth the trip."
  },
  {
    question: "Should I visit Chichicastenango if I only have 3 days in Antigua?",
    answer: "No. With only 3 days, prioritize experiences closer to Antigua: Acatenango or Pacaya volcano, walking tours of Antigua, and maybe one shorter day trip. Chichicastenango requires a full day (10–12 hours) and is better suited for travelers with 5+ days in Guatemala."
  },
  {
    question: "Can I take photos at Chichicastenango market?",
    answer: "Yes, but be respectful. Always ask permission before photographing people—many Indigenous vendors consider it intrusive or believe photos capture their spirit. The church interior prohibits photography during ceremonies. Market stalls, architecture, and street scenes are generally fine to photograph."
  },
  {
    question: "How much money should I bring to Chichicastenango?",
    answer: "Bring $50–$150 in cash depending on your shopping plans. Budget $5–$10 for lunch, $5–$10 for drinks/snacks, and $20–$100+ for shopping. Vendors prefer Guatemalan quetzales but accept US dollars (though you'll get a worse exchange rate). Few vendors accept credit cards."
  }
];

export const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Article",
      "headline": "Antigua to Chichicastenango: Complete Day Trip Guide (2025)",
      "description": "Everything you need to know about visiting Chichicastenango Market from Antigua: travel options, costs, what to buy, cultural tips, and whether it's worth the 3-hour drive.",
      "image": "https://public.readdy.ai/ai/img_res/5f7e98813df4b0138f75207153563ff8.jpg",
      "author": {
        "@type": "Organization",
        "name": "La Antigua Guatemala Travel Guide"
      },
      "publisher": {
        "@type": "Organization",
        "name": "La Antigua Guatemala Travel Guide",
        "logo": {
          "@type": "ImageObject",
          "url": "https://la-antigua-guatemala.com/logo.png"
        }
      },
      "datePublished": "2025-01-15",
      "dateModified": "2025-01-15",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://la-antigua-guatemala.com/antigua-to-chichicastenango"
      },
      "inLanguage": "en-US"
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://la-antigua-guatemala.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Day Trips",
          "item": "https://la-antigua-guatemala.com/day-trips-from-antigua-guatemala"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Antigua to Chichicastenango",
          "item": "https://la-antigua-guatemala.com/antigua-to-chichicastenango"
        }
      ]
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is Chichicastenango worth visiting from Antigua?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, if you have 5+ days in Guatemala and are interested in Indigenous culture, textiles, or photography. It's one of Central America's largest traditional markets. However, if you only have 3 days in Antigua, prioritize Acatenango or Pacaya volcano instead—the 6-hour round-trip drive is a significant time investment."
          }
        },
        {
          "@type": "Question",
          "name": "How do I get from Antigua to Chichicastenango?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The most common options are organized tours ($35–$50), shuttle services ($25–$35), or private drivers ($80–$120). Tours include a guide and cultural context. Shuttles are cheaper but offer no commentary. Private drivers give you the most flexibility. Chicken buses are possible but require multiple transfers and take 4+ hours each way."
          }
        },
        {
          "@type": "Question",
          "name": "What days is Chichicastenango market open?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The main market operates only on Thursday and Sunday. These are the only days worth visiting—the town is quiet on other days. Thursday tends to be less crowded with tourists than Sunday."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take to get from Antigua to Chichicastenango?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The drive takes 2.5–3.5 hours each way depending on traffic and your mode of transport. Tours and shuttles typically take 3–3.5 hours due to pickups. Private drivers can make it in 2.5 hours. Plan for a full-day trip (10–12 hours total including market time)."
          }
        },
        {
          "@type": "Question",
          "name": "Is Chichicastenango safe for tourists?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Chichicastenango is generally safe during market days when there's a strong tourist and police presence. Petty theft (pickpocketing) is the main concern in crowded areas. Keep valuables secure, don't flash cash, and stay aware of your surroundings. Avoid walking alone in empty side streets."
          }
        },
        {
          "@type": "Question",
          "name": "What should I buy at Chichicastenango market?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Popular items include handwoven textiles (huipiles, table runners, blankets), wooden masks, ceramics, jade jewelry, and leather goods. Textiles offer the best quality-to-price ratio. Expect to pay $15–$150 for quality textiles, $10–$80 for masks, and $5–$40 for ceramics. Always negotiate—vendors expect it."
          }
        },
        {
          "@type": "Question",
          "name": "Can I combine Chichicastenango with Lake Atitlán?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, this is a popular combination if you hire a private driver. Chichicastenango is roughly halfway between Antigua and Lake Atitlán. You can visit the market in the morning, then continue to Panajachel or another lakeside town (adds 1.5–2 hours). This works best as an overnight trip rather than a day trip."
          }
        },
        {
          "@type": "Question",
          "name": "Do I need a guide for Chichicastenango?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Not required, but recommended for first-time visitors. A guide provides cultural context about the K'iche' Maya traditions, explains the significance of Santo Tomás Church, and helps you navigate the market efficiently. Tours include guides; shuttles don't. You can also hire a local guide at the market for $20–$30."
          }
        },
        {
          "@type": "Question",
          "name": "What time should I leave Antigua for Chichicastenango?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Leave Antigua by 6:30–7:00 AM to arrive at the market by 9:30–10:00 AM when it's most active. The market peaks between 9 AM and 1 PM. Vendors start packing up after 2 PM. Plan to leave Chichicastenango by 2:30–3:00 PM to avoid evening traffic back to Antigua."
          }
        },
        {
          "@type": "Question",
          "name": "Is Chichicastenango market touristy?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, very. It's been on the tourist circuit for decades. However, it remains an important market for local K'iche' Maya communities who come to buy and sell goods. The scale and cultural significance are authentic, even if many vendors now cater to tourists. Thursday is less touristy than Sunday."
          }
        },
        {
          "@type": "Question",
          "name": "What's the difference between Chichicastenango and Antigua's markets?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Chichicastenango is 10x larger, focuses heavily on textiles and handicrafts, and serves as a regional hub for Indigenous communities. Antigua's markets (like the daily artisan market) are smaller, more convenient, but offer less variety and higher prices. If you're serious about buying textiles, Chichicastenango is worth the trip."
          }
        },
        {
          "@type": "Question",
          "name": "Should I visit Chichicastenango if I only have 3 days in Antigua?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. With only 3 days, prioritize experiences closer to Antigua: Acatenango or Pacaya volcano, walking tours of Antigua, and maybe one shorter day trip. Chichicastenango requires a full day (10–12 hours) and is better suited for travelers with 5+ days in Guatemala."
          }
        },
        {
          "@type": "Question",
          "name": "Can I take photos at Chichicastenango market?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, but be respectful. Always ask permission before photographing people—many Indigenous vendors consider it intrusive or believe photos capture their spirit. The church interior prohibits photography during ceremonies. Market stalls, architecture, and street scenes are generally fine to photograph."
          }
        },
        {
          "@type": "Question",
          "name": "How much money should I bring to Chichicastenango?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Bring $50–$150 in cash depending on your shopping plans. Budget $5–$10 for lunch, $5–$10 for drinks/snacks, and $20–$100+ for shopping. Vendors prefer Guatemalan quetzales but accept US dollars (though you'll get a worse exchange rate). Few vendors accept credit cards."
          }
        }
      ]
    }
  ]
};
